export default {
  userAddress: [],
  provinces: [],
  cities: [],
  districts: [],
  nearby: [],
  searchAddress: [],
  hotCity: []
}
